module.exports = __webpack_public_path__ + "img/shipo-map-vessel.92e70274.svg";